import { useFormik } from "formik";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { AiOutlineUser } from "react-icons/ai";
import RecoverPasswordEmailSentComponent from "./recover-password-email-sent-component";
import { recoverPasswordSchema } from "./validation/recover-password-validation";

function RecoverPasswordFormComponent() {
  const { i18n, t } = useTranslation();
  const [toggleComponent, setToggleComponent] = useState<boolean>(true);

  type InitialValuesType = {
    email: string;
  };
  const initialValues: InitialValuesType = {
    email: "",
  };

  const { values, errors, touched, handleChange, handleSubmit, handleBlur } =
    useFormik({
      initialValues: initialValues,
      validateOnChange: true,
      validateOnBlur: true,
      validationSchema: recoverPasswordSchema,
      onSubmit: async () => {},
    });

  return (
    <>
      {toggleComponent ? (
        <div
          dir={i18n.language === "ar" ? "rtl" : "ltr"}
          className="flex flex-col w-[425px] mobile:mx-4"
        >
          <p className="font-arMedium text-2xl mobile:text-lg text-black344">
            {t("forgetPassword.container.enterNewPassword")}
          </p>
          <form
            onSubmit={handleSubmit}
            className="flex flex-col justify-center items-center mt-4 mobile:mx-2 mobile:mt-8"
          >
            {/* Username Input */}
            <div className="flex flex-col gap-2">
              <label className="relative font-arMedium text-xl text-zinc700">
                {t("recoverPasswordForm.component.pleaseEnterEmail")}
                <AiOutlineUser
                  className={`${
                    i18n.language === "ar" ? "right-4" : "left-4"
                  } absolute bottom-[17px] text-zinc-300 text-2xl`}
                />
                <input
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  id="email"
                  type="text"
                  placeholder="a@example.sa"
                  className={`${
                    touched.email && errors.email
                      ? "border-secondary-50 focus:border-secondary-50"
                      : "border-zinc400 focus:border-mint-500"
                  } ${
                    i18n.language === "ar" ? "pl-4 pr-12" : "pr-4 pl-12"
                  } w-[425px] mobile:w-full border font-arMedium text-zinc700 text-lg rounded-2xl py-3 mt-2 placeholder-zinc-300 placeholder:font-arMedium placeholder:text-lg focus:outline-none caret-mint-500`}
                ></input>
              </label>
              {touched.email && errors.email && (
                <p className="text-base mobile:text-xs font-arMedium text-secondary-50">
                  {errors.email}
                </p>
              )}
            </div>

            {/* Send Button */}
            <button
              type="submit"
              onClick={() => {
                touched.email && errors.email == null ? (
                  setToggleComponent(false)
                ) : (
                  <></>
                );
              }}
              className="flex justify-center items-center font-arMedium text-xl mobile:text-xl text-zinc50 bg-mint-500 h-14 w-[345px] mobile:w-full rounded-2xl mt-14"
            >
              {t("recoverPasswordForm.component.send")}
            </button>
          </form>
        </div>
      ) : (
        <RecoverPasswordEmailSentComponent />
      )}
    </>
  );
}

export default RecoverPasswordFormComponent;
